import { useEffect, useRef, useState } from "react";
import { useAppContext } from "../../../Context";
import CalendarSelector from "../../calendars/CalendarSelector";
import { InputTimes, Textarea, Label } from "../../forms/formFields";
import { removeWhitespace } from "../../panels/SchedulePanel";
import moment from "moment";

interface AddAnnotationSideNavProps {
    date: string;
    currentTime: Date;
}

const AddAnnotationSideNav = ({ date, currentTime }: AddAnnotationSideNavProps) => {

    const navContext = useAppContext();

    useEffect(() => {
        console.log("currentTime", currentTime);
    }, [currentTime]);

    const [values, setValues] = useState({
        date: date,
        start_time: moment(currentTime).format('hh:mm:ss'),
        end_time: moment(currentTime).add(1, 'minutes').format('hh:mm:ss'),
        annotation_text: "",
        comments: ""
    });

    const annotationTextRef = useRef<HTMLTextAreaElement>(null);
    const commentsRef = useRef<HTMLTextAreaElement>(null);
    return (
        <form className="tw-p-20px tw-space-y-15px">
            <CalendarSelector id="coverageDate" name="Recording Date:" className={navContext.errors?.date ? '_form-error' : ''} 
					onBlur={() => navContext.setFieldStates({...navContext.fieldStates, "date": true})}
                    value={values.date}
					onChange={ e => {
												
												console.log(e.target.value);
												// setValues({...values, "date": e.target.value});
												// validateShiftDate(e.target.value);
					}}/>

            <InputTimes id="startTime" value={values.start_time} label="Start Time" className={navContext.errors?.start_time ? '_form-error' : ''} increments="1" min="0" max="12" placeholder="00" min2="0" max2="60" placeholder2="00" increments2="15"
					onBlur={() => navContext.setFieldStates({...navContext.fieldStates, "start_time": true})}
					onChange={ e => {
						if(removeWhitespace(e.target.value) !== removeWhitespace(values.start_time)) {
							console.log("Start Time", e.target.value);
							setValues({
								...values,
								"start_time": e.target.value
							});
							//validateStartTime(e.target.value);
						}
					}}
				/>

                <InputTimes id="endTime" value={values.end_time} label="End Time" className={navContext.errors?.end_time ? '_form-error' : ''} increments="1" min="0" max="12" placeholder="00" min2="0" max2="60" placeholder2="00" increments2="15"
					onBlur={() => navContext.setFieldStates({...navContext.fieldStates, "end_time": true})}
					onChange={ e => {
						if(removeWhitespace(e.target.value) !== removeWhitespace(values.end_time)) {
							console.log("End Time", e.target.value);
							setValues({
								...values,
								"end_time": e.target.value
							});
							//validateEndTime(e.target.value);
						}
					}}
				/>

                    <Label className="tw-pt-20px">
							Annotation Text
					</Label>
					<Textarea ref={ annotationTextRef } className={`${navContext.errors?.annotation_text ? '_form-error tw-text-5 tw-leading-normal ': 'tw-text-5 tw-leading-normal '} tw-w-full`} placeholder="Enter your annotation..." 
					onBlur={() => navContext.setFieldStates({...navContext.fieldStates, "annotation_text": true})}
					onChange={ e => {
						// setValues({...values, "custom_reason": e.target.value});
						// validateCustomReason(e.target.value);
					}}>{ values["annotation_text"] }</Textarea>


                    <Label className="tw-pt-20px">
							Comments
					</Label>
                    <Textarea ref={ commentsRef } className={`${navContext.errors?.comments ? '_form-error tw-text-5 tw-leading-normal ': 'tw-text-5 tw-leading-normal '} tw-w-full`} placeholder="Additional comments..." 
					onBlur={() => navContext.setFieldStates({...navContext.fieldStates, "comments": true})}
					onChange={ e => {
						// setValues({...values, "custom_reason": e.target.value});
						// validateCustomReason(e.target.value);
					}}>{ values["comments"] }</Textarea>
        </form>
    )
}

export default AddAnnotationSideNav;